import { Img } from "./DeckShell";

/* Avslutningsstripe (deles av deckene): teamet bak Norwegian AI Summit + leveransepartnere med nøkterne statuser
   (Unite/Apriil er forslag/tilbud, Grieghallen har gitt tilbud — ingen inngåtte avtaler påstås). Portretter i sort-hvitt, logoer monokrome. */
export const TEAM = [
  ["Martin Kviteberg", "CEO & Partner", "/images/team/martin-kviteberg.webp", "martin@norwegianaisummit.no"],
  ["Sarah Sleeman", "Partner", "/images/team/sarah-sleeman.webp"],
  ["Sigrid Kviteberg", "Partner · Technology · Global InTech AS", "/images/team/sigrid-kviteberg.webp"],
  ["Vernand Morency", "International Relations & Partnerships", "/images/team/vernand-morency.webp"],
];

export const DELIVERY = [
  ["Unite Event", "/logos/unite.svg", "unite", "Proposed delivery partner"],
  ["Grieghallen", "/logos/grieghallen.svg", "grieghallen", "Venue · offer received"],
  ["Cure", "/logos/cure.svg", "cure", "Proposed brand, media & distribution partner"],
];

export const TEAM_ASSETS = [...TEAM.map((t) => t[2]), ...DELIVERY.map((d) => d[1])];

export const TeamAndPartners = ({ className = "" }) => (
  <div className={`hd-tp ${className}`} data-testid="hd-team-partners">
    <div className="hd-tp-team">
      <span className="k">The team · Norwegian AI Summit</span>
      <ul>
        {TEAM.map(([n, r, img, mail]) => (
          <li key={n} data-testid={`hd-team-${n.split(" ")[0].toLowerCase()}`}>
            <Img src={img} alt={n} className="ph" draggable={false} />
            <span className="t"><b>{n}</b><i>{r}</i>{mail && <em>{mail}</em>}</span>
          </li>
        ))}
      </ul>
    </div>
    <div className="hd-tp-partners">
      <span className="k">Delivered with</span>
      <ul>
        {DELIVERY.map(([n, logo, cls, st]) => (
          <li key={n} data-testid={`hd-delivery-${cls}`}>
            <Img src={logo} alt={n} className={`lg ${cls}`} draggable={false} />
            <span className="st">{st}</span>
          </li>
        ))}
      </ul>
    </div>
  </div>
);
